// Preload audio elements for reliable replay
const correctSound = new Audio('/assets/sounds/clab-short.mp3');
const wrongSound = new Audio('/assets/sounds/wrong.mp3');
const clapSound = new Audio('/assets/sounds/clap-full.mp3');

// Set volume
correctSound.volume = 0.7;
wrongSound.volume = 0.7;
clapSound.volume = 0.7;

// Preload
correctSound.load();
wrongSound.load();
clapSound.load();

function playPreloaded(audio: HTMLAudioElement) {
  try {
    audio.currentTime = 0; // Reset to start for replay
    audio.play().catch(() => {});
  } catch (_) {}
}

export const playCorrect = () => playPreloaded(correctSound);
export const playWrong   = () => playPreloaded(wrongSound);
export const playClap    = () => playPreloaded(clapSound);
